export default __webpack_public_path__ + "static/media/Hooch_Booch_Can_Animation_SameSize.6cf3f0c2.gif";